/**
 * CountBadge — the quiet figure beside a card's eyebrow.
 *
 * The design puts a bare number next to "VENUE ROSTER" and a counted noun next
 * to "VENUE MAP" ("80 venues"). Same role in both: it says how much is in the
 * card without competing with the title, so it is drawn muted and tabular —
 * tabular because the figure changes as a filter narrows, and a proportional
 * numeral makes the heading shift sideways when it does.
 */
export interface CountBadgeProps {
  count: number;
  /**
   * Singular noun to count. Omit for a bare number. Pluralised by adding "s",
   * which is all the callers need; pass `plural` for anything else.
   */
  noun?: string;
  plural?: string;
}

export function CountBadge({ count, noun, plural }: CountBadgeProps) {
  const word = noun && (count === 1 ? noun : (plural ?? `${noun}s`));

  return (
    <span
      className="nb-tabular"
      style={{ fontSize: 12, color: 'var(--nb-subtle)', whiteSpace: 'nowrap' }}
    >
      {count.toLocaleString('en-US')}
      {word ? ` ${word}` : ''}
    </span>
  );
}
